import React from "react";
import cn from "clsx";
import ReactHtmlParser from "react-html-parser";
import { useTranslation } from "react-i18next";
import useIsSmallScreen from "@/hooks/useIsSmallScreen";
import { Product } from "@/services/productService";
import { useIsRTL } from "@/hooks";

import aiIconMob from "@/images/ai-image-message-mob-icon.svg";
import aiIconWeb from "@/images/ai-image-message-web-icon.svg";
import "./style.scss";

type Props = {
  item: Product;
  box?: boolean;
};

const AiGeneratedImageMessage: React.FC<Props> = ({ item, box }) => {
  const { isSmallScreen } = useIsSmallScreen();
  const isRTL = useIsRTL();
  const { t } = useTranslation("productDetails");

  const { height, bust, waist, hips, imageUrl } = item.modelProfile || {};
  const hasMetrics = height || bust || waist || hips;

  if (isSmallScreen && !box) {
    return (
      <div className="ai-badge-wrapper">
        <div className="ai-badge">
          <img
            src={imageUrl || aiIconMob}
            alt="Styled by AI"
            className="ai-badge__icon"
          />
          <span className="ai-badge__text">
            {ReactHtmlParser(item.modelProfile.title)}
          </span>
        </div>
      </div>
    );
  }

  return (
    <div className={cn("ai-box", { arabic: isRTL })}>
      <img
        src={imageUrl || aiIconWeb}
        alt="Styled by AI"
        className="ai-box__icon"
      />
      <div className="ai-box__text">
        <div className="ai-box__title">
          {ReactHtmlParser(item.modelProfile.title)}
        </div>
        <div className="ai-box__subtitle">
          {ReactHtmlParser(item.modelProfile.description)}
        </div>
        {hasMetrics && (
          <div className="ai-box__metrics">
            {height && <span>{t("model.height", { height })}</span>}
            {bust && <span>{t("model.bust", { bust })}</span>}
            {waist && <span>{t("model.waist", { waist })}</span>}
            {hips && <span>{t("model.hips", { hips })}</span>}
          </div>
        )}
      </div>
    </div>
  );
};

export default AiGeneratedImageMessage;
